import bezier from 'bezier-easing';

// explore various curves at https://easings.net/
export const easeOutCubic = bezier(0.33, 1, 0.68, 1);

export const easeInCubic = bezier(0.32, 0, 0.67, 0);
